<script>
import Base from './base.vue';
import autoAdd from '../mixin/auto-add';
import { flowTypes } from '@/common/service/page-config';

export default {
  name: 'BUY_NOW',
  extends: Base,
  mixins: [autoAdd],
  computed: {
    showIncreaseWithLargeMeetingPromo() {
      return this.$context.flow === flowTypes.buyNow &&
        !this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') &&
        this.$core.addonFilterKeys.includes('LARGE_MEETING')
    },
    showLargeMeetingPromoInComparison() {
      return this.$context.flow === flowTypes.buyNow &&
        (
          this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') ||
          this.$core.addonFilterKeys.includes('LARGE_MEETING')
        )
    },
  },
};
</script>
